import { TFunction } from 'i18next';
import { Timeline216 } from 'shared/assets/icons';
import { DateFormatOptions } from 'shared/types/date-format-options';
import { FilterDateRangeOption, FilterOptionType } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { WeekDays } from 'shared/types/week-days';

export type Options = {
  t: TFunction;
  dateFormat: DateFormatOptions;
  weekStartsOn: WeekDays;
};

export const createGoalActiveFilter = ({
  t,
  dateFormat,
  weekStartsOn,
}: Options): FilterDateRangeOption => ({
  id: FilterOptionKeys.GoalActive,
  label: t('context-menus.filtering.task.filters.goals-active.title'),
  icon: Timeline216,
  type: FilterOptionType.DateRange,
  dateFormat,
  weekStartsOn,
  canReset: true,
  hideUndefinedDateOptions: true,
  infoUrl: 'https://griply.app/help/features/filters',
});
